module.exports = __webpack_public_path__ + "static/media/delete.f41ae469.svg";